import type { CashbackPromptConfig, CashbackPromptConstraints } from "@types";
import { getDevFlags } from "@utils/dev-flags";

/**
 * Default conservative configuration values for cashback prompt constraints
 */
export const DEFAULT_CASHBACK_PROMPT_CONSTRAINTS: CashbackPromptConstraints = {
  lowBalancePercentage: 10, // 10% of last deposit
  minimumClaimableAmount: 0.1, // 0.1 THB (or equivalent currency)
  cooldownSeconds: 7200, // 2 hours
};

/**
 * Default cashback prompt configuration
 * Note: Feature enable/disable is controlled via Statsig experiment
 */
export const DEFAULT_CASHBACK_PROMPT_CONFIG: CashbackPromptConfig = {
  constraints: DEFAULT_CASHBACK_PROMPT_CONSTRAINTS,
};

/**
 * Get default cashback prompt configuration
 * This will be replaced with BE config mapping when backend is ready
 * Dev flags can override constraints for QA testing
 */
export function getCashbackPromptConfig(): CashbackPromptConfig {
  const devFlags = getDevFlags();

  if (devFlags?.cashbackPromptConfig) {
    return {
      constraints: {
        ...DEFAULT_CASHBACK_PROMPT_CONSTRAINTS,
        ...devFlags.cashbackPromptConfig,
      },
    };
  }

  return DEFAULT_CASHBACK_PROMPT_CONFIG;
}

/**
 * Adapter function to map backend configuration to frontend config
 * TODO: Implement when BE config is available
 */
export function adaptBackendConfig(backendConfig: unknown): CashbackPromptConfig {
  // Placeholder for future BE config mapping
  // For now, return default config
  return DEFAULT_CASHBACK_PROMPT_CONFIG;
}
